import { FC } from 'react';

import { GiftEntry } from '@telialt/common-order-cart/src/entries/GiftEntry';
import { EntryWithGift } from '@telialt/models/src/EshopModel';

import { formatVariantOptionValue } from '../../helpers/formatVariantOptionValue';
import { toSmallImage } from '../utils';

export const GiftEntryConnected: FC<{ entry: EntryWithGift }> = ({ entry }) => {
    const productVariantOptions = entry.product.baseOptions?.[0]?.selected?.variantOptionQualifiers
        ?.map(formatVariantOptionValue)
        .filter(Boolean)
        .join(', ');

    return (
        <GiftEntry
            name={entry.product.name}
            image={toSmallImage(entry.product.images)}
            variantOptions={productVariantOptions}
            price={entry.totalPrice}
            copyrightFee={entry.copyrightFee}
        />
    );
};
